import { render } from "./LesAnimateursPage.vue?vue&type=template&id=8b12793c"
import script from "./LesAnimateursPage.vue?vue&type=script&lang=js"
export * from "./LesAnimateursPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__